module.exports = __webpack_public_path__ + "static/media/400381_02.7fb4d2a4.png";